<div>
  <div class="title title--big">Сотрудники</div>
</div>

<app-tabs [justifyContent]="'center'">
  <app-tab [title]="'Справочник'" [id]="'directory'">
    <div class="mt-32 pt-8">
      <div class="grid">
        <div class="grid__box">
          <app-role-access [action]="'disable'" [permission]="'employee.add'" [placement]="'bottom-left'">
            <button data-role-element type="button" class="button" id="appCreateUser" (click)="createUser()">Добавить сотрудника</button>
          </app-role-access>
        </div>
        <div class="grid__box grid__box--size-min">
          <div class="grid">
            <div class="grid__box grid__box--size-min">Операции со справочником:</div>
            <div class="grid__box grid__box--size-min">
              <app-role-access [action]="'disable'" [permission]="'employee.export'" [placement]="'bottom-right'">
                <button data-role-element id="appExportUsers" (click)="exportUsers()">
                  <a class="link link--dotted-gray-dark">Экспорт</a>
                </button>
              </app-role-access>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pos-r">
      <app-loader *ngIf="usersDataLoading"></app-loader>
      <app-users-filter [filterData]="filterData" [isOneUserDisplay]="isOneUserDisplay"></app-users-filter>
      <app-users-list
        [filterData]="filterData"
        [userDataIsLoaded]="userDataIsLoaded"
        [userExpanded]="userExpanded"
        [userListFiltered]="userListFiltered"
        [paginationBlock]="paginationBlock"
        [emptyMessage]="emptyMessage"
        (onChangeUserExpanded)="onChangeUserExpanded($event)"
      ></app-users-list>
    </div>
  </app-tab>
  <app-tab [title]="'Квалификации'" [id]="'qualification'" *ngIf="isAdministrator">
    <app-users-qualification></app-users-qualification>
  </app-tab>
</app-tabs>
